import { eEstadoDocumento } from "../common/enumModel";
import { IFilterMaestroDocumentoModel } from "../interfaces/maestro-documento/IFilterMaestroDocumentoModel";


export class FilterMaestroDocumentoModel implements IFilterMaestroDocumentoModel {        
    id: number[];
    documento: string;
    idEstado: eEstadoDocumento;
    page: number;
    pageSize: number;

    constructor(){
        this.id = [];
        this.documento = '';
        this.idEstado = eEstadoDocumento.ACTIVO;
        this.page = 1;
        this.pageSize = 30;
    }
}